import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0e8c2c31&scoped=true"
import script from "./main.js?vue&type=script&lang=js&external"
export * from "./main.js?vue&type=script&lang=js&external"
import style0 from "./main.vue?vue&type=style&index=0&id=0e8c2c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c2c31",
  null
  
)

export default component.exports